export default __webpack_public_path__ + "static/media/close.37a5b190.svg";